import Client from "../shared/services/Client";
import querystring from "querystring";
import appConfig from "../utils/appConfig";

const SHEERID_API_URL = appConfig().sheerIdApiUrl;

function validateStudentInfo(
    email: string,
    { id, firstName, lastName, dateOfBirth }: StudentInfo,
    redirectUrl: string
): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    return Client.post("/api/student/verification", {
        organizationId: id,
        firstName,
        lastName,
        dateOfBirth,
        email,
        redirectUrl
    });
}

function fetchSchools({ value, country }: {value: string; country: string}): Promise<any> { // eslint-disable-line @typescript-eslint/no-explicit-any
    const query = {
        type: "UNIVERSITY",
        includeLocation: true,
        name: value,
        country
    };
    const url = `${ SHEERID_API_URL }/search?${ querystring.stringify(query) }`;

    return Client.get(url, { external: true });
}

const SheerId = {
    validateStudentInfo,
    fetchSchools
};

export default SheerId;
